import { Injectable, inject } from '@angular/core';
import { MatIconRegistry } from '@angular/material/icon';
import { DomSanitizer } from '@angular/platform-browser';

@Injectable({
  providedIn: 'root'
})
export class IconRegistryService {
  private readonly iconRegistry = inject(MatIconRegistry);
  private readonly sanitizer = inject(DomSanitizer);


  public registerIcons(): void {
    // Registrar iconos SVG personalizados
    this.iconRegistry.addSvgIcon(
      'app-face',
      this.sanitizer.bypassSecurityTrustResourceUrl('assets/face-icon.svg')
    );
    
    this.iconRegistry.addSvgIcon(
      'app-whatsapp',
      this.sanitizer.bypassSecurityTrustResourceUrl('assets/whatsapp-icon.svg')
    );
  }

  /**
   * Método para registrar iconos adicionales si es necesario
   */
  public registerIcon(name: string, url: string): void {
    this.iconRegistry.addSvgIcon(
      name,
      this.sanitizer.bypassSecurityTrustResourceUrl(url)
    );
  }
} 